/**
 * Утилита для сброса скролла на всех уровнях
 */
export function resetScroll() {
  if (typeof window === 'undefined') return
  
  // Сбрасываем скролл для window
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  
  // Сбрасываем скролл для document.documentElement и document.body
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  
  // Сбрасываем скролл для #app контейнера
  const appContainer = document.getElementById('app')
  if (appContainer) {
    appContainer.scrollTop = 0
  }
  
  // Сбрасываем скролл для всех основных контейнеров
  const containers = document.querySelectorAll(
    '.dashboard-container, .profile-container, .market-container, ' +
    '.positions-history-container, .dashboard-content, .profile-content, ' +
    '.market-content, .admin-screen-container, .admin-screen-content, ' +
    '.splash-container, .welcome-container, .onboarding-container, ' +
    '.faq-container, .admin-container'
  )
  containers.forEach(container => {
    if (container) {
      container.scrollTop = 0
    }
  })
  
  // Сбрасываем скролл для всех модальных окон
  const modals = document.querySelectorAll('.modal-overlay, .modal-content, .level-modal-overlay')
  modals.forEach(modal => {
    if (modal) {
      modal.scrollTop = 0
    }
  })
}






